<template>
  <h1 class="font-header mb-4 text-6xl max-md:text-4xl max-sm:text-3xl">
    <slot />
  </h1>
</template>
